<template>
  <div>
    <div
      v-if="results && results.scores"
      id="metricsRow1"
      class="row"
      aria-hidden="true"
    >
      <div class="col-sm-7">
        <div
          id="scoreRow"
          class="row public-speaking-row1"
        >
          <div class="col-xs-4 text-center">
            <span class="evaluate-label dial-charts">
              Vocal Delivery
            </span>
            <div class="chart-wrapper chart-wrapper-250">
              <div id="overallContainer">
                <dial-chart
                  tooltip-id="overallContainer"
                  :recording="recording"
                  :wavesurfer="wavesurfer"
                  metric="overall"
                  :speaker-num="speakerNum"
                />
              </div>
            </div>
          </div>
          <div class="col-xs-4 text-center">
            <span class="evaluate-label dial-charts">
              Strength of Opening
            </span>
            <div class="chart-wrapper chart-wrapper-250">
              <div id="strengthOpeningContainer">
                <dial-chart
                  tooltip-id="strengthOpeningContainer"
                  :recording="recording"
                  :wavesurfer="wavesurfer"
                  metric="strengthOfOpening"
                  :speaker-num="speakerNum"
                />
              </div>
            </div>
          </div>
          <div class="col-xs-4 text-center">
            <span class="evaluate-label dial-charts">
              Clarity
            </span>
            <div class="chart-wrapper chart-wrapper-250">
              <div id="clarityContainer">
                <dial-chart
                  tooltip-id="clarityContainer"
                  :recording="recording"
                  :wavesurfer="wavesurfer"
                  metric="clarity"
                  :speaker-num="speakerNum"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          id="dialRow"
          class="row"
        >
          <div class="col-xs-4 text-center">
            <span class="evaluate-label">
              Pace
            </span>
            <div class="chart-wrapper chart-wrapper-250">
              <div id="paceContainer">
                <gauge-chart
                  tooltip-id="paceContainer"
                  :recording="recording"
                  :wavesurfer="wavesurfer"
                  metric="pace"
                  :speaker-num="speakerNum"
                />
              </div>
            </div>
          </div>
          <div class="col-xs-4 text-center">
            <span class="evaluate-label">
              Pausing
            </span>
            <div class="chart-wrapper chart-wrapper-250">
              <div id="pausingContainer">
                <gauge-chart
                  tooltip-id="pausingContainer"
                  :recording="recording"
                  :wavesurfer="wavesurfer"
                  metric="pauseToTalk"
                  :speaker-num="speakerNum"
                />
              </div>
            </div>
          </div>
          <div class="col-xs-4 text-center">
            <span class="evaluate-label">
              Upspeak
            </span>
            <div class="chart-wrapper chart-wrapper-250">
              <div id="upspeakContainer">
                <gauge-chart
                  tooltip-id="upspeakContainer"
                  :recording="recording"
                  :wavesurfer="wavesurfer"
                  metric="upspeak"
                  :speaker-num="speakerNum"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-5 text-center">
        <div class="chart-wrapper chart-wrapper-400">
          <div id="wordChartContainer">
            <recording-wordspotting
              tooltip-id="wordChartContainer"
              :recording="recording"
              :wavesurfer="wavesurfer"
              :speaker-num="speakerNum"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      id="varietyRow"
      class="row"
      aria-hidden="true"
    >
      <div class="col-sm-4 text-center">
        <span class="evaluate-label">
          Variety of Volume
        </span>
        <div class="chart-wrapper chart-wrapper-300">
          <div id="varietyVolumeContainer">
            <variety-chart
              tooltip-id="varietyVolumeContainer"
              :recording="recording"
              :wavesurfer="wavesurfer"
              metric="varietyVolume"
              :speaker-num="speakerNum"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-4 text-center">
        <span class="evaluate-label">
          Variety of Pace
        </span>
        <div class="chart-wrapper chart-wrapper-300">
          <div id="varietyPaceContainer">
            <variety-chart
              tooltip-id="varietyPaceContainer"
              :recording="recording"
              :wavesurfer="wavesurfer"
              metric="varietyPace"
              :speaker-num="speakerNum"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-4 text-center">
        <span class="evaluate-label">
          Variety of Pitch
        </span>
        <div class="chart-wrapper chart-wrapper-300">
          <div id="varietyPitchContainer">
            <variety-chart
              tooltip-id="varietyPitchContainer"
              :recording="recording"
              :wavesurfer="wavesurfer"
              metric="varietyPitch"
              :speaker-num="speakerNum"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartHelper from '../utils/ChartHelper';
import DialChart from '../forms/DialChart';
import GaugeChart from '../forms/GaugeChart';
import RecordingWordspotting from './RecordingWordspotting';
import VarietyChart from '../forms/VarietyChart';

export default {
  components: {VarietyChart, RecordingWordspotting, DialChart, GaugeChart},
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'speakerNum'],
};

</script>